/**
 * findSelection
 * finds the checked radiobutton in a radiogroup.
 *
 * @param {array of input[type=radio]} inputs
 * @returns {input[type=radio]} the checked radiobutton
 */
export function findSelection(inputs) {
	if (!inputs) {
		return;
	}
	return inputs.find((input) => input.checked);
};